import { AxiosGet } from "../useApi";

const route = 'users';

export function GetUsers(params) {
    return AxiosGet(route, params)
}


